import { HttpService } from 'core/modules/network-service';
import { get } from 'lodash';

// local dependencies
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc AccessManagementUserGroups defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { AccessManagementUserGroupsService } from 'services/accessManagementUserGroups';
 *
 * // create service instance and send/cancel request
 * const accessManagementUserGroupsService = new AccessManagementUserGroupsService();
 * const result = await accessManagementUserGroupsService.fetchData( '<user-id>' ); // fetch data
 * accessManagementUserGroupsService.cancel(); // cancel an active request
 */
export class AccessManagementUserGroupsService extends HttpService {

    // make request and fetch data
    async fetchComponentData( { url } ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url
            } );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    userGroups: get( response, 'body.component.data.state.userGroups', {} ),
                    options: get( response, 'body.component.data.options', {} ),
                    ...get( response, 'body.component.structure', {} )
                }
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    async validateNewUserGroupName( { url, data } ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data
            } );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: get( response, 'body.component.data', {} )
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
            };
        }
    }

    async fetchUserSearchResults( { url, data } ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data
            } );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: { users: get( response, 'body.component.data.state.users' ) }
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE
            };
        }
    }

    async submitFormData( { url, data } ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data
            } );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: get( response, 'body.component.data', {} )
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE
            };
        }
    }
    

    // make request and fetch data
    async deleteUserGroupData(  { url = {}, data = {} } = {} ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: { data: data, context: {} }
            } );

            const status = get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE );

            if ( SERVICE_RESPONSE_STATUS.FAILURE === status ) {
                return {
                    status,
                    data: get( response, 'body.component.data', {} )
                };
            }
    
            return {
                status,
                data: get( response, 'body.component.structure', {} )

            };

        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    async fetchGroupMemberList( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: { data: data, context: {} }
            } );

            const status = get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE );

            if ( SERVICE_RESPONSE_STATUS.FAILURE === status ) {
                return {
                    status,
                    data: get( response, 'body.component.data', {} )
                };
            }
    
            return {
                status,
                data: get( response, 'body.component.data.state.users', [] )

            };

        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}
